import {Step} from 'react-joyride';
import {tourText} from '../../texts/libraryText';
import {stepConfig} from './libraryStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getLibrarySteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Library');
